/*
* Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
*
* Licensed under the Apache License, Version 2.0 (the "License").
* You may not use this file except in compliance with the License.
* A copy of the License is located at
*
*     http://aws.amazon.com/apache2.0/
*
* or in the "license" file accompanying this file.
* This file is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR
* CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions
* and limitations under the License.
*/

<template>
  <v-app>
    <div
      id="app"
      data-app
    >
      <v-menu
        v-if="user"
        class="menu"
      >
        <template slot="progress">
          <v-progress-linear
            v-if="isLoading"
            height="10"
            color="blue darken-3"
            :indeterminate="true"
          />
        </template>
      </v-menu>
      <v-container
        id="mainContainer"
        fluid
        fill-height
      >
        <router-view />
      </v-container>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { Menu } from '@/components';
import { eventHub } from '../config/eventhub';
import './custom.scss';

window.LOG_LEVEL = 'VERBOSE';

export default {
  name: 'App',
  components: {
    'v-menu': Menu,
  },
  data() {
    return {
      isLoading: false,
      y: 'bottom',
      x: null,
      mode: '',
      timeout: 0,
      loadingText: 'Loading data',
      loadCounter: 0,
    };
  },
  computed: {
    ...mapGetters(['loading']),
    user() {
      return this.$store.state.userStore.user;
    },
  },
  created() {
    eventHub.$on('before-request', this.showLoading);
    eventHub.$on('request-error', this.hideLoading);
    eventHub.$on('after-response', this.hideLoading);
    eventHub.$on('response-error', this.hideLoading);
  },
  beforeDestroy() {
    eventHub.$off('before-request', this.showLoading);
    eventHub.$off('request-error', this.hideLoading);
    eventHub.$off('after-response', this.hideLoading);
    eventHub.$off('response-error', this.hideLoading);
  },
  methods: {
    showLoading() {
      this.loadCounter += 1;
      this.isLoading = true;
    },
    hideLoading() {
      this.loadCounter -= 1;
      if (this.loadCounter === 0) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
html {
  overflow-y: hidden !important;
}
html,
body {
  height: 100%;
  overflow: hidden !important;
}
body {
  margin: 0;
  background-color: white;
  background: linear-gradient(180deg, rgba(39, 74, 127, 0.7), transparent);
  background-size: cover;
  height: 100%;
}

#mainContainer {
  margin-top: 64px;
  overflow: auto;
  height: calc(100vh - 64px);
  display: block;
  padding-top: 0;
}

#app {
  font-family: "Roboto", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

h1 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.v-card__text {
  word-break: break-all;
}

[class^="Form__formSection"] {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue